import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
  }
  #root {
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.fonts};
    font-style: normal;
    font-weight: bold;
    font-size: 22px;   
    color: ${({ theme }) => theme.WHITE};
    width: 100%;
    height: 100%;
    min-height: 100vh;
  }
  @media (max-width: 475px) {
    #root {
      font-size: 18px; 
    }
  }
`;
